import { Component, OnInit, TemplateRef } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { UserService } from 'src/app/account/services/user.service';
import { AppComponent } from 'src/app/app.component';
import { ModalComponent } from 'src/app/components/modal/modal.component';
import { GlobalVariables } from 'src/app/shared/global';
import { AuthService } from '../auth.service';
import { DialogComponent, DialogData } from 'src/app/components/dialog/dialog.component';

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.css'],
})
export class LoginComponent implements OnInit {
  form: FormGroup;
  isVisibility = false;
  saveData = true;

  constructor(
    private router: Router,
    private authService: AuthService,
    private toastr: ToastrService,
    private app: AppComponent,
    private userService: UserService,
    private dialog: MatDialog
  ) {}

  ngOnInit(): void {
    this.form = new FormGroup({
      email: new FormControl('', [Validators.email, Validators.required]),
      password: new FormControl('', [Validators.minLength(5), Validators.required]),
      saveData: new FormControl(true),
    });
    this.form.get('email').setValue(sessionStorage.getItem('user'));
    this.form.get('password').setValue(sessionStorage.getItem('password'));
    this.form.updateValueAndValidity();
    sessionStorage.clear();
  }

  login(): void {
    if (this.form.get('saveData').value == true) {
      sessionStorage.setItem('user', this.form.get('email').value);
      sessionStorage.setItem('password', this.form.get('password').value);
    }
    this.authService
      .authentication(this.form.get('email').value, this.form.get('password').value)
      .then((res) => {
        if (res.token) {
          sessionStorage.setItem('token', res.token);
          sessionStorage.setItem('userName', res.user.name);
          sessionStorage.setItem('cecid', JSON.stringify(res.user?.cec_id));
          sessionStorage.setItem('routes', JSON.stringify(res.permissions?.routes));
          if (res.permissions?.permissions) {
            const pmsString = JSON.stringify(res.permissions.permissions);
            sessionStorage.setItem('pms', btoa(pmsString));
          }
          if (res.pendencies !== undefined) {
            sessionStorage.setItem('pendencies', JSON.stringify(res.pendencies));
          }

          if (res.user?.avatar) {
            sessionStorage.setItem('userAvatar', res.user?.avatar?.file_name);
          }

          this.router.navigateByUrl('/dashboard');
        }
        this.userService.setUserData('1');
      })
      .catch((error) => {
        this.toastr.error(error.error.message || 'Algo de errado aconteceu');
      });
  }

  requestPassword() {
    let dialogRef = this.dialog.open(ModalComponent, {
      height: '400px',
      width: '300px',
      panelClass: 'request-password-modal',
      id: 'request-password-modal',
      data: {
        title: 'Recuperar senha',
        text: 'Informe o e-mail para recuperar sua senha',
      },
    });
  }

  changeIsVisibility() {
    this.isVisibility = !this.isVisibility;
  }

  openRegisterModal(template: TemplateRef<any>) {
    this.dialog.open(template, {
      width: '350px',
      panelClass: 'register-modal',
    });
  }
}
